import { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { vehicleSpecsImageURL } from "../../store/constants/baseUrl";
import "pure-react-carousel/dist/react-carousel.es.css";



import { BsInfoCircle } from "react-icons/bs";
import VehicleDetailsModal from "./VehicleDetailsModal";
import TruckAndCrewWarningModal from "./TruckAndCrewWarningModal";



const SliderComponent = ({
  vehicles,
  vehicleTypeId,
  handleUpdateBookingObject,
  handleEstimatePrice,
  isTruckAndMooverWarningSeen,
  setIsTruckAndMooverWarningSeen,
}) => {
  const [isVehicleDetailShow, setisVehicleDetailShow] = useState(false);
  // Modal states
  const [showTruckWarning, setShowTruckWarning] = useState(false);
  const [pendingSlideIndex, setPendingSlideIndex] = useState(null);



  const [currentIndex, setCurrentIndex] = useState(0);

  const getCurrentVehicleIndex = () => {
    try {
      if (!Array.isArray(vehicles) || !vehicles.length) return 0;
      if (typeof vehicleTypeId !== "undefined" && vehicleTypeId !== null) {
        const idx = vehicles.findIndex((vehicle) => vehicle.id === vehicleTypeId);
        if (idx >= 0) return idx;
      }
      return currentIndex || 0;
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
      return 0;
    }
  };

  const scrollTab = (index) => {
    const selectedVehicle = vehicles?.[index];
    if (!selectedVehicle) return;

    setCurrentIndex(index);

    // --- Set Vehicle in Booking Object
    handleUpdateBookingObject("vehicleTypeId", selectedVehicle.id, "13.2");
    handleUpdateBookingObject("SelectedVehicleName", selectedVehicle.title || selectedVehicle.name, "13.2");

    // --- Labour logic for large trucks (1004 / 1005)
    if (selectedVehicle.id === 1004 || selectedVehicle.id === 1005) {
      const raw = localStorage.getItem("VBO") || "{}";
      const vbo = JSON.parse(raw) || {};
      const currentLabour = vbo.labourNeeded || 1;

      const adjustedLabour = currentLabour < 2 ? 2 : currentLabour; // Minimum 2
      handleUpdateBookingObject("labourNeeded", adjustedLabour, "suggested_labour_slider");

      // Update localStorage VBO too
      localStorage.setItem(
        "VBO",
        JSON.stringify({ ...vbo, labourNeeded: adjustedLabour, vehicleTypeId: selectedVehicle.id, vehicle: selectedVehicle })
      );
    } else {
      // Normal vehicle, labour unchanged
      const raw = localStorage.getItem("VBO") || "{}";
      const vbo = JSON.parse(raw) || {};
      localStorage.setItem(
        "VBO",
        JSON.stringify({ ...vbo, vehicleTypeId: selectedVehicle.id, vehicle: selectedVehicle })
      );
    }

    // // Optional: call price estimate after labour adjustment
    // handleEstimatePrice();
  };


  // console.log("Slider3 component loaded" ,  vehicleSpecsImageURL ); ;


  useEffect(() => {
    try {
      if (!Array.isArray(vehicles) || !vehicles.length) return;

      const raw = localStorage.getItem("VBO") || "{}";
      const vbo = JSON.parse(raw || "{}") || {};

      const savedId = (vehicleTypeId ?? vbo.vehicleTypeId ?? vbo.vehicleTypeID) ?? 1002;
      let idx = vehicles.findIndex((v) => v.id === savedId);
      if (idx < 0) idx = vehicles.findIndex((v) => v.id === 1002);
      if (idx < 0) idx = 0;

      setCurrentIndex(idx);

      const chosenVehicle = vehicles[idx];
      if (chosenVehicle) {
        const chosenId = chosenVehicle.id;
        const chosenName = chosenVehicle.title || chosenVehicle.name || "";

        if (typeof handleUpdateBookingObject === "function") {
          if (vehicleTypeId !== chosenId) handleUpdateBookingObject("vehicleTypeId", chosenId, "13.2");
          try {
            const rawVBO = localStorage.getItem("VBO") || "{}";
            const parsed = JSON.parse(rawVBO || "{}") || {};
            if (parsed.SelectedVehicleName !== chosenName) handleUpdateBookingObject("SelectedVehicleName", chosenName, "13.2");
            if (!parsed.vehicle || parsed.vehicle.id !== chosenId) handleUpdateBookingObject("vehicle", chosenVehicle, "13.2");
          } catch (err) { handleUpdateBookingObject("SelectedVehicleName", chosenName, "13.2"); }
        }

        try {
          const raw2 = localStorage.getItem("VBO") || "{}";
          const parsed2 = JSON.parse(raw2 || "{}") || {};
          const merged = { ...parsed2, vehicleTypeId: chosenId, SelectedVehicleName: chosenName, vehicle: chosenVehicle };
          localStorage.setItem("VBO", JSON.stringify(merged));
          try { window.dispatchEvent(new CustomEvent("vboUpdated", { detail: { vehicleTypeId: chosenId } })); } catch (e) { }
        } catch (err) { Sentry.captureException(err); }
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log("Error initializing slider from VBO", error);
    }
  }, [vehicles, vehicleTypeId, handleUpdateBookingObject]);

  useEffect(() => {
    try {
      if (!Array.isArray(vehicles) || !vehicleTypeId) return;
      const selected = vehicles.find((v) => v.id === vehicleTypeId);
      if (!selected) return;
      const selectedName = selected?.title || selected?.name || "";
      const raw = localStorage.getItem("VBO") || "{}";
      const vbo = JSON.parse(raw || "{}");
      if (vbo.SelectedVehicleName !== selectedName) {
        vbo.SelectedVehicleName = selectedName;
        localStorage.setItem("VBO", JSON.stringify(vbo));
      }
    } catch (error) { Sentry.captureException(error); console.log(error); }
  }, [vehicleTypeId, vehicles]);

  // VBO listeners
  useEffect(() => {
    const handleStorage = (ev) => {
      try {
        if (ev.key && ev.key !== 'VBO') return;
        const raw = localStorage.getItem('VBO') || '{}';
        const vbo = JSON.parse(raw || '{}') || {};
        const id = vbo.vehicleTypeId ?? vbo.vehicleTypeID ?? null;
        if (id == null) return;
        const idx = Array.isArray(vehicles) ? vehicles.findIndex((v) => v.id === id) : -1;
        if (idx >= 0 && idx !== currentIndex) setCurrentIndex(idx);
      } catch (err) { Sentry.captureException(err); }
    };
    const handleCustom = (ev) => {
      try {
        const raw = localStorage.getItem('VBO') || '{}';
        const vbo = JSON.parse(raw || '{}') || {};
        const id = vbo.vehicleTypeId ?? vbo.vehicleTypeID ?? null;
        if (id == null) return;
        const idx = Array.isArray(vehicles) ? vehicles.findIndex((v) => v.id === id) : -1;
        if (idx >= 0 && idx !== currentIndex) setCurrentIndex(idx);
      } catch (err) { Sentry.captureException(err); }
    };
    window.addEventListener('storage', handleStorage);
    window.addEventListener('vboUpdated', handleCustom);
    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('vboUpdated', handleCustom);
    };
  }, [vehicles, currentIndex]);

  // **Navigation with one-time modal**
  const handleSlideNavigation = (newIndex) => {
    if (!isTruckAndMooverWarningSeen && !showTruckWarning) {
      setPendingSlideIndex(newIndex);
      setShowTruckWarning(true);
    } else {
      // Already seen → move directly
      scrollTab(newIndex);
      handleEstimatePrice();
    }
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between gap-x-3 w-full h-[147px] my-auto">
        {/* LEFT ARROW */}
        <button
          type="button"
          disabled={getCurrentVehicleIndex() === 0}
          onClick={() => handleSlideNavigation(currentIndex - 1)}
          className="flex items-center justify-center p-0 m-0 disabled:opacity-40"
          aria-label="Previous vehicle"
        >
          <img
            src="/images/NewUiIcons/ChevronLightPurple.svg"
            alt="Prev icon"
            className="w-[12] h-[6] object-contain"
          />
        </button>

        {/* SLIDER */}
        <div className="flex-1 overflow-hidden h-[130px]">
          <div
            className="flex h-full transition-transform duration-300 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {vehicles?.map((vehicle, index) => (
              <div key={index} className="flex-shrink-0 w-full flex items-center justify-center">
                <div className="relative w-full max-h-[170px] flex items-center justify-center">
                  <img
                    src={vehicleSpecsImageURL + vehicle?.pictureUrl}
                    className="object-center w-full h-auto max-h-[170px]"
                    alt={vehicle?.title}
                  />
                  <button
                    type="button"
                    title="Vehicle Details"
                    onClick={() => setisVehicleDetailShow(true)}
                    className="absolute top-6 right-2 rounded-full"
                    aria-label={`Show info for ${vehicle?.title || "vehicle"}`}
                  >
                    <BsInfoCircle className="text-blue-800" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT ARROW */}
        <button
          type="button"
          disabled={getCurrentVehicleIndex() === (vehicles?.length || 0) - 1}
          onClick={() => handleSlideNavigation(currentIndex + 1)}
          className="flex items-center justify-center p-0 m-0 disabled:opacity-40"
          aria-label="Next vehicle"
        >
          <img
            src="/images/NewUiIcons/ChevronLightPurple.svg"
            alt="Next icon"
            className="w-[12] h-[6] object-contain rotate-180"
          />
        </button>
      </div>

      <VehicleDetailsModal
        isVehicleDetailShow={isVehicleDetailShow}
        setisVehicleDetailShow={setisVehicleDetailShow}
      />

      <TruckAndCrewWarningModal
        open={showTruckWarning}
        onClose={() => {
          setShowTruckWarning(false);
          setIsTruckAndMooverWarningSeen(true); // mark as seen
          setPendingSlideIndex(null);
        }}
        onConfirm={() => {
          if (pendingSlideIndex !== null) {
            scrollTab(pendingSlideIndex);
            handleEstimatePrice();
          }
          setShowTruckWarning(false);
          setPendingSlideIndex(null);
          setIsTruckAndMooverWarningSeen(true); // mark as seen
        }}
      />
    </div>
  );
};

export default SliderComponent;
